export default {
  RESPONSABLES_CAMPAGNE: 'Campaign managers',
  DELETE_CONFIRMATION_TITLE: 'Delete Confirmation',
  DELETE_CONFIRMATION_MESSAGE: 'Are you sure you want to delete this item?',
  SELECT: 'Select',
  LOADING: 'Loading...',
  NOT_FOR_MEDICAL_DATA: 'This service is not intended for transmitting or storing medical data.',
  JOindre_un_document_de_justification_facultatif: 'Join a justification document (optional)',
  SELECT_USER_TO_VIEW_CALENDAR: 'Select a employee to view the calendar',
  SELECT_USER_CONGE: 'Please select an employee',
  DECLARERCONGE: 'Declare a leave for an employee',
  DEMANDERCONGE: 'Request a leave',
  LEAVE_MODAL_SUBTITLE: 'Fill in the details of your request',
  DISPONIBILITES_EQUIPE: 'Team availability',
  TYPE_CONGE: 'Leave type',
  COLLABORATEUR: 'Employee',
  DATE_CONFLIT:
    'The start date and/or end date conflicts with an existing leave. Please check the dates and try again.',
  PERIODE: 'Period',
  JOURNEE: 'Day',
  DEMI_JOURNEE: 'Half-day',
  MATIN: 'Morning',
  APRES_MIDI: 'Afternoon',
  DATE_DEBUT: 'Start date',
  DATE: 'Date',
  DATE_FIN: 'End date',
  TIME: 'Time',
  COMMENTAIRE_FACULTATIF: 'Comment (optional)',
  IMPORTER_FICHIER: 'Upload a file',
  CHARGEMENT: 'Loading...',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  SOLDE_CONGES: 'Leave balance',
  RTT: 'RTT',
  CONGES_PAYES: 'Paid leave',
  JOURS: 'days',
  JOUR: 'day',
  TOTAL_JOURS_DEMANDES: 'Total requested days',
  LEAVE_BALANCE_EXCEEDED: 'Warning: the requested days exceed your leave balance.',
  EN_COURS: 'In progress...',
  SOUMETTRE: 'Submit',
  LIGNEINSEREE: 'Inserted line',
  LIGNESINSEREES: 'Inserted lines',
  LIGNEREJETEE: 'Rejected',
  LIGNESREJETEES: 'Rejected',
  TOTAL: 'Total',
  DATE_DEMARRAGE: 'Date of start',
  AES_WARNING: 'You have used AES verification: The credit required to sign this document is ',
  RETIRERDELAISTEDESPERSONNESMANAGEES: 'Remove from managed persons list',
  VoirLaFicheDetailleeDuCollaborateur: 'View employee detailed profile',
  TEXTIA:
    'These documents are generated by AI and are provided for informational purposes only. Please review their content and adapt them with professional help before use.',
  RETIRER: 'Remove',
  ACTIONS: 'Actions',
  actions: 'Actions',
  ENTERPRISE_LANGUAGES: 'Enterprise languages',
  LANGUAGES: {
    fr: 'French',
    en: 'English',
    es: 'Spanish',
    de: 'German',
    it: 'Italian',
    ar: 'Arabic',
  },
  FILL_PREVIOUS_FIELD: 'Please fill in the previous period of trial',
  NEW_MAIL_RECEIVED: 'New mail received from the candidate',
  MAIL_COMMUNICATION_INFO:
    'All communication with the candidate must be done through this address, otherwise it will not be recorded.',
  CREATED_ON: 'Creation date',
  ERROR_OCCURRED: 'Day already validated',

  NOMMODELE: 'Model name',
  TEXTINFOPERSONALISER:
    'You do not have to put special characters for the first and last names, you can copy them directly and the AI ​​will automatically replace the fields with the right information.',
  AJOUTMODELEPERSONALISER: 'Add a custom template',
  ENREGISTREMODEL: 'Save',
  PERSONALIZED_MODEL_VIEW_TITLE: 'View personalized template',
  PERSONALIZED_MODEL_EDIT_TITLE: 'Edit personalized template',
  PERSONALIZED_MODEL_SAVE_CHANGES: 'Save changes',
  PERSONALIZED_MODEL_CREATE_SUCCESS: 'Personalized template added successfully',
  PERSONALIZED_MODEL_CREATE_ERROR: 'Error while adding the personalized template',
  PERSONALIZED_MODEL_UPDATE_SUCCESS: 'Personalized template updated successfully',
  PERSONALIZED_MODEL_UPDATE_ERROR: 'Error while updating the personalized template',
  PERSONALIZED_MODEL_DELETE_TITLE: 'Delete personalized template',
  PERSONALIZED_MODEL_DELETE_CONFIRM: 'Are you sure you want to delete this personalized template?',
  PERSONALIZED_MODEL_DELETE_SUCCESS: 'Personalized template deleted successfully',
  PERSONALIZED_MODEL_DELETE_ERROR: 'Error while deleting the personalized template',
  PERSONALIZED_MODEL_LOAD_ERROR: 'Unable to load the personalized template',
  PERSONALIZED_MODEL_UNSAVED_CONFIRM: 'Unsaved changes will be lost. Do you want to continue?',
  PERSONALIZED_MODEL_BADGE: 'Personalized',
  PERSONALIZED_MODEL_CARD_DESCRIPTION: 'Template created by your company. Click to preview it.',
  PERSONALIZED_MODEL_ADD_DESCRIPTION: 'Create a reusable template from your own content.',
  PERSONALIZED_MODEL_LAST_UPDATED: 'Updated on',
  PERSONALIZED_MODEL_USE: 'Use',
  PERSONALIZED_MODEL_VIEW: 'View',
  PERSONALIZED_MODEL_EMPTY_TITLE: 'No personalized templates yet',
  PERSONALIZED_MODEL_EMPTY_TEXT: 'Add a personalized template to view, edit, and reuse it in document generation.',

  FORMATIONMENU: 'Training',
  FOLLOW: 'Follow',
  PLAN: 'Plan',
  TEMPLATES: 'Models',
  DOCUMENT_TO_SIGN: 'Document to sign',
  URLNONVALIDE: 'Invalid URL.',
  RECRUTEMENTTEXT1: 'Company logo',
  RECRUTEMENTTEXT2: 'Presentation video',
  RECRUTEMENTTEXT3: 'Company description',
  RECRUTEMENTTEXT4: 'Website',
  RECRUTEMENTTEXT5: 'Keywords',
    RECRUTEMENTTEXT6: 'Banner',
  RECRUTEMENTTEXT7: 'Other',
  RECRUTEMENTTEXT8: 'Save',
  EMAIL_ACCEPTANCE_TEMPLATE: 'Application acceptance email template',
  CUSTOMIZE: 'Customize',
  EMAIL_REJECTION_TEMPLATE: 'Application rejection email template',
  EMAIL_INTERVIEW_INVITATION_TEMPLATE: 'Interview invitation email template',
  EMAIL_TEST_SUBMISSION_TEMPLATE: 'Test submission email template',
  PERSONALISERLIENACCES: 'Customize your access links',
  MSGPERSONALISERACCES:
    'This field allows you to customize the portal URL by choosing a unique name. This name will be used to generate the portal access URL. Please use only letters, numbers, and hyphens, without spaces or special characters (/, &, ?, etc.) to avoid altering the URL.',
  MENUTEST: 'Test management',
  IMPORT: {
    TITLE: 'File Import',
    TABLE: {
      DATE: 'Date of import',
      DESCRIPTION: 'Description',
      STATUS: 'Status',
      NOM: 'File name',
      PERIOD: 'Month and year',
      AUTHOR: 'Imported by',
      NOT_APPLICABLE: '—',
      UNKNOWN_AUTHOR: 'Author unavailable',
    },
    STATUS: {
      EN_COURS: 'In progress',
      TERMINE: 'Completed',
      ERREUR: 'Error',
      PARTIAL: 'Partial',
      UNCERTAIN: 'To review',
    },
    BUTTON: {
      IMPORT: 'Import',
      EXTERNAL_API: 'Import leave balance via API',
      PAIE_API: 'Import payslip via API',
      AUTO_PAIE: 'Automatic payslip import',
      PAYROLL_FILE: 'Import payroll file',
      API_MENU: 'Import via API',
      FILE_MENU: 'Import via file',
    },
    MODE: {
      AUTO: 'Automatic',
      MANUAL: 'Manual',
    },
    EXTERNAL_API_MODAL: {
      TITLE: 'Import from external API',
      SELECT_API: 'Select an integration',
      SELECT_API_PLACEHOLDER: 'Choose an API...',
      SELECT_SITE: 'Select a site',
      SELECT_SITE_PLACEHOLDER: 'Choose a site...',
      SELECT_MONTH: 'Month',
      SELECT_YEAR: 'Year',
      MONTH_PLACEHOLDER: 'Choose a month...',
      YEAR_PLACEHOLDER: 'Choose a year...',
      TRIGGER: 'Start import',
      CANCEL: 'Cancel',
      SUCCESS: 'Import started successfully',
      ERROR: 'Error while starting the import',
      NO_INTEGRATIONS: 'No compatible integration found',
      VALIDATION_REQUIRED: 'Please fill in all fields',
      CONFIRM_TITLE: 'Confirm import',
      CONFIRM_MESSAGE: 'Are you sure you want to start importing leave balances from the external API? This action will import leave balance data.',
      MONTHS: {
        JANUARY: 'January',
        FEBRUARY: 'February',
        MARCH: 'March',
        APRIL: 'April',
        MAY: 'May',
        JUNE: 'June',
        JULY: 'July',
        AUGUST: 'August',
        SEPTEMBER: 'September',
        OCTOBER: 'October',
        NOVEMBER: 'November',
        DECEMBER: 'December',
      },
    },
    PAIE_API_MODAL: {
      TITLE: 'Payslip import via API',
      CONFIRM_TITLE: 'Confirm payslip import',
      CONFIRM_MESSAGE: 'Are you sure you want to start importing payslip lines from the external API? This will import the pay slips for the selected period.',
      SUCCESS: 'Payslip import started successfully',
    },
    AUTO_PAIE_MODAL: {
      TITLE: 'Automatic payslip import scheduling',
      EXISTING_TITLE: 'Existing schedules',
      NEW_TITLE: 'New schedule',
      DAY_LABEL: 'Day of month',
      HOUR_LABEL: 'Hour',
      SELECT_MONTH: 'Month of data to import',
      SELECT_YEAR: 'Year of data to import',
      HINT: 'The import will run automatically every month, on the selected day and time. The imported period will match the execution month with the current year.',
      PERIODE_PREFIX: 'Data:',
      CREATE_BTN: 'Schedule',
      VALIDATION_REQUIRED: 'Please fill in all fields',
      CREATE_SUCCESS: 'Schedule created successfully',
      CREATE_ERROR: 'Error creating the schedule',
      UPDATE_ERROR: 'Error updating the schedule',
      DELETE_TITLE: 'Delete schedule',
      DELETE_MESSAGE: 'Are you sure you want to delete this automatic schedule?',
      DELETE_SUCCESS: 'Schedule deleted successfully',
      DELETE_ERROR: 'Error deleting the schedule',
      DELETE_BTN: 'Delete',
      STATUS_ACTIVE: 'Active',
      STATUS_INACTIVE: 'Inactive',
      TOGGLE_HINT: 'Enable / disable the automatic schedule',
      NO_SCHEDULES: 'No automatic schedule configured',
      BACKEND_NOT_READY: 'Automatic schedule management is not available on this server yet.',
    },
    PAYROLL_FILE_HISTORY: 'Payroll file import',
    // Payroll file review must explain each destructive operation before the user consents.
    PAYROLL_FILE: {
      TITLE: 'Import a payroll file',
      EYEBROW: 'Payroll data import',
      SUBTITLE: 'Analyze your file, review the proposed employees and payroll fields, then confirm the period and values to import.',
      STEP_SOURCE: 'File and period',
      STEP_MAPPING: 'Column mappings',
      STEP_REVIEW: 'Review and import',
      SOURCE_TITLE: 'Select your file',
      // File size is the sole business quota; parser and AI safety protections still apply.
      SOURCE_HINT: 'One CSV, XLS or XLSX file, up to 5 MB. No business quota on rows, payroll fields or values. Manual parsing stays local; the file is sent to the server only when you start AI analysis. Reading and analysis safety protections remain active.',
      CHOOSE_FILE: 'Browse files',
      CHANGE_FILE: 'Change file',
      PERIOD_TITLE: 'Payroll period',
      PERIOD_HINT: 'All values in the file will be assigned to this month.',
      READING_TITLE: 'File parsing',
      IDENTITY_TITLE: 'Identify employees',
      IDENTITY_HINT: 'Map the available identifiers. If first and last names share one column, keep the full name.',
      MAPPING_TITLE: 'Map payroll fields',
      MAPPING_HINT: 'Match each value column to a monthly payroll field. Search is available inside each dropdown.',
      REVIEW_TITLE: 'Review before importing',
      REVIEW_HINT: 'Check employee matches, correct values and explicitly ignore rows to exclude.',
      ROW_COUNT: '{{count}} row(s) in the preview',
      NO_WRITE_HINT: 'No payroll values are written during preparation.',
      FILE: 'Excel or CSV file',
      SHEET: 'Worksheet',
      HEADER_ROW: 'Header row',
      ENCODING: 'CSV encoding',
      SEPARATOR: 'CSV delimiter',
      COMMA: 'Comma',
      SEMICOLON: 'Semicolon',
      TAB: 'Tab',
      NUMBER_FORMAT: 'Number format',
      NUMBER_FR: 'Decimal comma',
      NUMBER_EN: 'Decimal point',
      SOURCE_COLUMN: 'File column',
      SEARCH_SOURCE_COLUMN: 'Search file columns',
      PAYROLL_COLUMN: 'Payroll field',
      SEARCH_PAYROLL_COLUMN: 'Search payroll fields',
      ADD_MAPPING: 'Add a mapping',
      REMOVE_MAPPING: 'Remove mapping',
      OPTIONAL: 'Optional',
      LAST_NAME: 'Last name',
      NAME_OR_FULL_NAME: 'Last or full name',
      FULL_NAME: 'Full name in one column',
      FIRST_NAME: 'First name',
      EMPLOYEE_NUMBER: 'Employee number',
      PROFESSIONAL_EMAIL: 'Work email',
      SOCIAL_SECURITY_NUMBER: 'Social security number',
      SOURCE_ROW: 'Source row',
      VALUE: 'Value',
      PREVIEW: 'Preview',
      SELECT_EMPLOYEE: 'Select employee',
      SEARCH_EMPLOYEE: 'Search employees',
      SUGGESTIONS: 'Employees suggested for this name',
      SUGGESTIONS_REQUIRE_REVIEW: 'Verify the employee before confirming the match.',
      AUTO_MATCH_WARNING: 'Automatically matched to the top name result. Check this identity before importing.',
      UNMAPPED_IDENTITY_REVIEW: 'Another column in this row contains unmapped data: check identifiers before choosing an employee.',
      SEARCH_PAYROLL_FALLBACK: 'Also search former employees',
      SEARCH_PAYROLL_HINT: 'To find a former employee, try a surname alone or an employee number.',
      MATCH_UNAVAILABLE: 'Name suggestions are unavailable. The standard search remains available.',
      NO_EMPLOYEE: 'No matching employee',
      NO_COLUMNS: 'No importable monthly payroll fields available',
      VALID: 'Valid',
      NEEDS_REVIEW: 'Review or ignore',
      MANUAL_MATCH: 'Manually matched',
      IGNORED: 'Ignored',
      IGNORE: 'Ignore',
      RESTORE_ROW: 'Review row again',
      INSERT_ROW: 'Insert this row',
      INSERT_ALL: 'Insert all',
      CLEANUP: 'Clear the affected data before inserting new values',
      BLOCKED_ROWS: 'Correct or explicitly ignore the {{count}} rows needing review.',
      CONFIRM_TITLE: 'Confirm payroll import',
      CONFIRM_APPEND: 'Data for {{period}} will be imported. Existing data will not be cleared. Values already present for an employee and payroll field will be rejected.',
      CONFIRM_CLEANUP: 'For {{period}}, only existing values for the employees and payroll fields of the cells being inserted will be deleted. Other data will remain unchanged. If an insertion fails, deleted data will not be restored.',
      PROGRESS: '{{done}} of {{total}} values processed',
      STOP: 'Stop after the current operation',
      RESUME: 'Resume after validation',
      SUMMARY: 'Import summary',
      SUCCEEDED_ROWS: 'Fully inserted rows: {{count}}',
      REJECTED_ROWS: 'Failed or partial rows: {{count}}',
      PARTIAL_ROWS: 'Of which partially inserted: {{count}}',
      IGNORED_ROWS: 'Ignored rows: {{count}}',
      PENDING_ROWS: 'Unprocessed rows: {{count}}',
      ROW_INSERTED: 'Inserted',
      ROW_PARTIAL: 'Partially inserted',
      ROW_REJECTED: 'Rejected',
      ROW_PENDING: 'Not processed',
      ROW_UNCERTAIN: 'Uncertain outcome',
      UNCERTAIN_ROWS: 'Rows with an outcome to verify: {{count}}',
      INSERTED_VALUES: 'Confirmed inserted values: {{count}}',
      DELETED_VALUES: 'Existing values deleted: {{count}}',
      DELETED_WITHOUT_INSERT: 'Data deleted, new value not inserted. No automatic restoration.',
      UNCERTAIN: 'Uncertain outcome. Check Remuneration before trying again.',
      CLOSE_WARNING: 'Completed operations remain effective. The report and file will not be retained after closing.',
      AI: {
        EYEBROW: 'Recommended analysis',
        TITLE: 'Understand the file structure with AI',
        // Proposed associations can be corrected directly without enabling a separate review mode.
        HINT: 'Start analysis to identify employees and propose payroll fields without writing payroll data. Review the proposals and edit mappings directly when needed.',
        IDENTITY_SUMMARY: 'Automatically extracted identifiers: employee number, work email and full name. If the employee number is missing or not found, search checks the other identifiers. Conflicts and duplicates require manual review.',
        IDENTIFYING: 'Looking up proposed employees from source identifiers…',
        PROPOSED_EMPLOYEE: 'Proposed employee, to review',
        CONFIRM_EMPLOYEE: 'Confirm this employee',
        IDENTITY_CONFIRMED: 'Choice confirmed for this source; payroll validation is still required before import.',
        IDENTITY_STATUS: {
          proposed: 'Proposed match, not automatically assigned.',
          not_found: 'No exact match: search for the employee manually.',
          ambiguous: 'Multiple matches: no automatic assignment.',
          conflict: 'Conflicting identifiers: no automatic assignment.',
          incomplete: 'Search incomplete or unavailable: manual review required.',
        },
        MATCHED_BY: { employee_number: 'Proposed by exact employee number', professional_email: 'Proposed by exact email', full_name: 'Proposed by exact full name' },
        INSTRUCTIONS: 'Analysis instructions and clarifications',
        ANALYZE: 'Analyze the file with AI',
        EXPLICIT_RUN: 'Each click uploads the file and starts a new analysis that may use AI credits.',
        SOURCE_PERIOD: 'Period identified in the source:',
        SOURCE_MATRIX: 'All source employees and values',
        SOURCE_MATRIX_HINT: 'Source values remain read-only, without implicit sums. Employee proposals are available before units and confirmations, even without a target month. Confirm an employee only after checking; payroll validation remains mandatory. Excluded TOTAL columns and examples are listed in excluded regions.',
        SOURCE_COUNTS: '{{employees}} source employee(s), {{groups}} payroll group(s) and {{values}} value(s), accessible across all pages.',
        SOURCE_READONLY_BLOCKED: 'All extracted values remain available. Requested clarifications or an unknown source period only block applying choices and importing.',
        SOURCE_EMPLOYEE: 'Source employee',
        SOURCE_ALIAS: 'Source #{{id}}',
        SOURCE_CODE: 'Payroll code',
        SOURCE_SELECTED: 'Selected for preparation, not authorized for import',
        SOURCE_NOT_SELECTED: 'Not selected for import',
        SOURCE_NO_VALUE: 'No source value for this occurrence',
        SOURCE_EMPLOYEE_PAGES: 'Employee pages',
        SOURCE_GROUP_PAGES: 'Payroll group pages',
        EXCLUDED_REGIONS: '{{count}} explicitly excluded source region(s), including identified global totals or examples',
        PERIOD: { single_month: 'Single month', range: 'Cumulative period', unknown: 'Unknown period' },
        RANGE_WARNING: 'The source period does not match one target month. Values will not be divided or prorated. Assigning them to {{period}} requires your explicit consent.',
        CUMULATIVE_CONSENT: 'I agree to assign these cumulative source-period values to the single selected target month {{period}}.',
        QUESTIONS: 'Clarifications requested by analysis',
        REANALYZE_HINT: 'These points still need review. An answer or local acknowledgement does not replace file evidence or the checks required before import.',
        CLARIFICATION_TITLE: 'Clarifications needed before the result',
        CLARIFICATION_PENDING: 'Analysis is waiting for your answers. This is not a final result: no employee lookup or import preparation will start before a new analysis.',
        CLARIFICATION_REQUIRED: 'Explicitly answer every question: choose an option or write a free-text answer. No answer is preselected.',
        CLARIFICATION_FREE: 'Other / free-text answer',
        CLARIFICATION_ANSWER: 'Your answer',
        CLARIFICATION_LENGTH: 'Combined instructions, questions and answers: {{count}} / {{limit}} characters.',
        CLARIFICATION_TOO_LONG: 'The total limit of {{limit}} characters is exceeded. Shorten your answers, or edit the instructions to restart without the answer history. No text is truncated and no request is sent.',
        CLARIFICATION_HINT: 'This button sends the original file with your clarifications and starts a new analysis that may use AI credits. Answers are neither source evidence nor consent to import. Changing the file or instructions clears this session’s answers.',
        CLARIFICATION_CONTINUE: 'Answer and continue',
        WARNINGS: 'Warnings and reconciliations to review',
        ACKNOWLEDGE: 'I have checked these warnings, reconciliations and excluded regions.',
        METRICS: 'Measurements to retain',
        METRIC: { base: 'Base', salarial: 'Employee amount', patronal: 'Employer amount' },
        UNIT: 'Confirmed unit or currency for this group (e.g. EUR, hours, quantity, %)',
        UNIT_HINT: 'Optional unit or currency hint (does not confirm any group)',
        GROUP_UNITS_REQUIRED: 'Enter and verify the unit or currency for every group to import. A global hint does not replace this confirmation.',
        TOTALS: 'Subtotals and gross totals',
        NO_AGGREGATION: 'Details, subtotals and totals stay separate. Do not add them into the same destination. Each selected group requires a distinct target payroll field.',
        SUBTOTALS: 'Explicitly include subtotals',
        GROSS_TOTALS: 'Explicitly include gross totals',
        KIND: { detail: 'Detail', subtotal: 'Subtotal', gross_total: 'Gross total' },
        EVIDENCE: 'View {{count}} source values and references',
        GROUP_COUNT: '{{count}} source group(s) visible, including ignored groups, without implicit aggregation',
        GROUP_INCLUDED: 'To import after review and confirmation',
        GROUP_IGNORED: 'Ignored for import: no mapping entered or group not selected',
        RESTORE_GROUP: 'Review this group again',
        EXCLUDED_COUNT: '{{count}} explicitly excluded observation(s)',
        RESTORE_SOURCES: 'Review all excluded observations again',
        UNASSIGNED: 'Ignored — choose a destination',
        DESTINATION_HINT: 'Choose at least one importable field. Unmapped fields remain visible and ignored; each retained field needs a distinct destination.',
        TARGET_CONSENT: 'I separately confirm the unit or currency and destination of groups to import, without double counting details and totals.',
        APPLY: 'Confirm these choices and check payroll',
        IMMUTABLE_VALUES: 'Analyzed values remain exactly as reread from the source. Run analysis again to correct interpretation; these values cannot be edited in the preview.',
        FINAL_SELECTION: 'The groups and units below will be imported into the confirmed destinations:',
        CONSENT_REQUIRED: 'No writes started: also confirm cumulative values being assigned to the target month in the final confirmation.',
      },
      ERROR: {
        FILE: 'Invalid, empty or unsupported file.',
        // Agent read bounds need a distinct explanation from the upload-size limit.
        ANALYSIS_REGION: 'The cell range requested by the agent is too large. It must be read in parts.',
        ANALYSIS_CONTEXT: 'The context sent to the AI exceeds the allowed budget. This rejection is not related to the file size.',
        ANALYSIS_BUDGET: 'AI analysis has reached its cumulative budget. No import has been performed.',
        ANALYSIS_ITERATIONS: 'AI analysis has reached its call limit before it could be finalized. No import has been performed.',
        ANALYSIS_EXCLUSIONS: 'The totals or example exclusions proposed by the AI are not sufficiently proven by the file. No import has been performed.',
        LIMIT: 'The file exceeds 5 MB or processing reached a reading or analysis safety protection. No business quota on rows, payroll fields or values applies.',
        MAPPING: 'Check the period and column mappings.',
        IDENTITY: 'Employee missing, ambiguous or identifiers inconsistent. Select the employee.',
        REFERENCE: 'Reference not found or unavailable.',
        COLUMN: 'This field is not directly importable as a monthly value.',
        VALUE: 'Invalid value. No implicit conversion is performed.',
        FILE_DUPLICATE: 'Multiple rows target the same employee, payroll field and month.',
        EXISTING_VALUE: 'A value already exists for this employee, payroll field and month.',
        NO_VALUE: 'This row contains no value to insert.',
        ACCESS: 'Import is restricted to administrators with payroll administrator privileges.',
        ENCRYPTION: 'Payroll encryption is unavailable. No writes will be started.',
        SERVICE: 'Import preparation is unavailable.',
        HISTORY_START_FAILED: 'Unable to open the import history. No payroll write has started.',
        HISTORY_UPDATE_FAILED: 'The import history could not be confirmed. Payroll data already processed remains effective; check the summary before closing.',
      },
    },
  },
  MOTCLEINFO:
    'Add representative keywords (tags) for your company (e.g.: IT, Start-up, financial sector, innovation, remote work). These keywords will help better identify and categorize your company.',
  DETAILS: 'Details',
  SOUSCRIREMAINTENANT: 'Souscrire maintenant',
  SOUSCRIREABONNEMENT: 'Subscribe to a subscription',
  TEXTABONNEMENT0: 'to one of our formulas',
  TEXTABONNEMENT1: 'It seems that you do not have an active subscription. Subscribe now to the ',
  TEXTABONNEMENT2: 'to unlock access to all our modules and exclusive features.',
  PERONALISERPARAMETRE:
    'Customize your platform by enabling or disabling your modules here, according to your subscription and needs.',
  REFRESHAPPLICATION: 'Refresh to apply the changes.',
  LOGIN_MFA_SETTING_TITLE: 'Multi-factor authentication',
  LOGIN_MFA_SETTING_DESCRIPTION:
    "A verification code is sent to the user's email address when they try to sign in, unless this feature is disabled.",
  LOGIN_MFA_SETTING_ENABLED: 'Enabled',
  MOBILE_DEVICE_WHITELIST_SETTING_TITLE: 'Mobile device whitelist',
  MOBILE_DEVICE_WHITELIST_SETTING_DESCRIPTION:
    'When enabled, only active devices registered in Material, assigned to the user, and individually authorized can sign in through the mobile app. Website login is unaffected.',
  MOBILE_DEVICE_WHITELIST_SETTING_ENABLED: 'Enabled',
  SECURITY_PAGE_TITLE: 'Enterprise security',
  SECURITY_SECTION_EYEBROW: 'Security settings',
  SECURITY_SECTION_TITLE: 'Authentication and access',
  SECURITY_SECTION_DESCRIPTION: 'Configure authentication and mobile access for collaborator accounts.',
  SECURITY_LOADING: 'Loading security settings',
  SECURITY_SAVING: 'Saving...',
  SECURITY_LOAD_ERROR: 'Unable to load the enterprise security settings.',
  SECURITY_SAVE_SUCCESS: 'Security settings updated successfully.',
  SECURITY_SAVE_ERROR: 'Unable to update the security settings.',
  VOTRECREDITIA: 'Your AI Credits',
  VOTRECREDITSIGNATURE: 'Your Signature Credits',
  CREDITS: 'Credits',
  MSGTITRESUGGESTION:
    'These are existing candidates in the CVtheque who are eligible for this job offer but have not applied',
  NEW: 'New',
  ECHECOPERATION: 'Operation failed. Please try again.',
  LIGNEINSERE: 'Inserted line',
  LIGNEREJETER: 'Rejected line',
  MODETRAVAIL: 'work mode',
  LOISIRS: 'Hobbies',
  SITE: 'Site',
  SERVICE: 'Service',
  TELEPHONEPRO: 'Professional phone',
  COMPETENCESPRES: 'Skills',
  MSGPRES1: 'Open chat',
  MSGPRES2: 'Suggest an appointment',

  AUCUNVIDEO: 'No video available at the moment. Please check back later.',
  AUCUNPRESENTATION: 'No description is available at the moment.',
  PRESENTATION: 'Presentation',
  CONTRAT: 'Contract',
  DATEDEBUTCONTRAT: 'Start date of contract',
  DATEFINCONTRAT: 'End date of contract',
  DATEENTREEGROUPE: 'Group entry date',
  FILTER: 'Filter',
  NO_RESULTS: 'No results found',
  AUCUNMANAGER: 'No manager found',
  AUCUNMANAGER_SELECTIONNE: 'No manager selected',

  EQUIPE: 'Team',

  SELECTIONNEREQUIPE: 'Select a team',
  SELECTIONNERSITE: 'Select a site',
  FILTREREQUIPE: 'Filter teams',
  FILTRERSITE: 'Filter sites',
  AUCUNEEQUIPETROUVEE: 'No team found',
  AUCUNSITETROUVE: 'No site found',

  MSGEQUIPEINFO:
    'If you have not yet created your teams, you can assign this collaborator to the "Unassigned" option. Once your teams are created, you can easily assign this collaborator to the correct team.',
  REFUSCANDIDAT: 'Reject the candidate',
  COPIER: 'Copy',
  COPIEREMAIL: 'Copy the email address',
  COPIEEMAILSUCCESS: 'Email copied successfully',
  EMAIL_COPIED: 'Email copied successfully',
  MESSAGE_COPIED: 'Message copied successfully',
  COPY_ERROR: 'Copy error',
  SKILLS: 'Skills',
  COPIEQUESTIONS: 'Copy questions',
  COPIEQUESTIONSSUCCESS: 'Questions successfully copied',
  MODAL_AUTO_CLOSED: 'The window has been automatically closed after 5 minutes of inactivity',
  FERMER: 'Close',
  SUGGESTIONQUESTIONS: 'Here is a suggestion of 10 questions:',
  QUESTIONSPOSERLORSENTRETIEN: 'Suggested questions to ask candidates during the interview',
  ASSIGNEROFFRE: 'Assign to an offer',
  EFFECTUERACTION: 'Perform an action',
  AUTRESCANDIDATS: 'Other candidates',
  CANDIDATS: 'Candidates',
  BACK: 'Back',
  TRIERPARDATE: 'Sort by date',
  PLUSRECENT: 'Most recent',
  PLUSANCIEN: 'Oldest',

  AUCUNCANDIDATTROUVE: 'Currently, no candidates have been found.',
  VOICIQUESTION: 'Here is a suggestion of 10 questions :',

  // Keys for candidate tooltip in Kanban
  PHOTOPROFIL: 'Profile picture',
  RESUMECV: 'CV Summary',
  HISTORIQUE: 'History',
  // Labels for detailed user profile version comparisons.
  USER_HISTORY: {
    TITLE: 'Change history',
    LOADING: 'Loading history…',
    LOAD_ERROR: 'Unable to load change history.',
    EMPTY: 'No changes recorded.',
    SYSTEM: 'System',
    OLD_VALUE: 'Old value',
    NEW_VALUE: 'New value',
    FIELDS: {
      prenom: 'First name',
      nom: 'Last name',
      photo_principale: 'Profile picture',
      date_entre: 'Start date',
      fonction: 'Position',
      date_fin: 'End date',
      nouvelle_recrue: 'New starter',
      idequipe: 'Team',
      date_naissance: 'Date of birth',
      genre: 'Gender',
      mail_personnel: 'Personal email',
      user_langue: 'Language',
      pays_user: 'Country',
      ville_user: 'City',
      adresse_user: 'Address',
      code_postal: 'Postal code',
      telephone: 'Personal phone',
      lien_linkedin: 'LinkedIn profile',
      num_securite_social: 'Social security number',
      num_passport: 'Passport number',
      cin: 'Identity document number',
      nationalite: 'Nationality',
      user_contact_urgence: 'Emergency contact',
      relation_user_urgence: 'Emergency contact relationship',
      phone_user_urgence: 'Emergency contact phone',
      adresse_user_urgence: 'Emergency contact address',
      uuid_manager: 'Manager',
      telephone_professionel: 'Work phone',
      situation_familiale: 'Marital status',
      lieu_naissance: 'Place of birth',
      identite_verso: 'Identity document (back)',
      identite_recto: 'Identity document (front)',
      num_enfants: 'Number of children',
      complement_adress: 'Address line 2',
      qualification: 'Qualification',
      date_autorisation_embauche: 'Hiring authorization date',
      date_autorisation_licenciement: 'Dismissal authorization date',
      departement_naissance: 'Birth department',
      date_entree_groupe: 'Group start date',
    },
  },
  RESEAUXSOCIAUX: 'Social networks',
  CVSOUMIS: 'This CV has been submitted for the position of',
  PASPOSTEAPPLIQUE: 'No position applied',
  COMPTERENDUCV: 'CV report',
  APROPOS: 'About the candidate',
  NOMPRENOM: 'Full name',
  NATIONALITE: 'Nationality',
  DATENAISSANCE: 'Date of birth',
  ADRESSE: 'Address',
  EMAIL: 'Email',
  NUMTELEPHONE: 'Phone number',
  NOM: 'Last name',
  PRENOM: 'First name',
  CORRESPONDANCEAVEC: 'Match with the position',
  // RELANCERANALYSE: 'Re-run the analysis by selection criteria',
  // LANCERANALYSE: 'Run the analysis by selection criteria',
  RELANCERANALYSE: 'Re-run the analysis',
  LANCERANALYSE: 'Run the analysis',
  OFFREEMPLOI: 'Job offer',
  ANALYSE: 'Analysis',
  CANDIDATNECORRESPONDPAS: 'The candidate does not match the selection criteria for the job offer.',
  ANALYSEPOUSSE: 'Advanced analysis by AI is available only for the candidate attached to the offer.',
  QUESTIONSSUGGEREES: 'Suggested questions',
  COMPETENCES: 'His/Her skills',
  POSTESUGGERES: 'Suggested positions',
  PASPOSTESUGGERE: 'No suggested positions',
  NOTES: 'Notes',
  EXPERIENCE: 'Experience',
  FORMATION: 'Education',
  CERTIFICATIONS: 'Certifications',
  LESDOCUMENTSDECANDIDAT: 'Candidate documents',
  AJOUTERUNDOCUMENT: 'Add a document',
  PROCESSUSDERECRUTEMENT: 'Recruitment process',
  ASSIGNERcetteoffre: 'Assign to this offer',
  SUGGERERCANDIDAT: 'Suggest candidates',
  LISTECANDIDATSSUGGERER: 'List of suggested candidates',
  MESCANDIDATS: 'My candidates',
  CANDIDATDEJAASSIGNE: 'This candidate is already assigned to this offer',
  CANDIDATNONASSIGNE: 'Assign this candidate to this offer',
  RENSEIGNERFROMDOCUMENT: 'Fill in from a document',
  INFOPERSONELLE: 'Personal Information',
  LIEUNAISSANCE: 'Place of birth',
  CODEPOSTAL: 'Postal code',
  COMPLEMENTADRESSE: 'Address complement',
  COORDONNEES: 'Contact details',
  DOCUMENTIDENTITEVERSO: 'ID document back side',
  DOCUMENTIDENTITERECTO: 'ID document front side',
  DOCUMENTSIDENTITE: 'Identity documents',
  NUMEROSECUSOCIALE: 'Social security number',
  CODESIGLE: 'Sigle code',
  ID_TYPE: 'Identity Documents',
  VILLE: 'City',
  VOIRDOCEXISTANT: 'View existing document',
  REINITIALISER: 'Reset',
  AUTORISATIONSADMINISTRATIVES: 'Administrative Authorizations',
  MANAGER: 'Manager',
  EMPLOIETPOSITION: 'Job and Position',
  NOMDUCONTACTURGENT: 'Emergency Contact Name',
  NUMERODUCONTACTURGENT: 'Emergency Contact Number',
  NOMBREDENFANTS: 'Number of Children',
  VEUF: 'Widowed',
  NON_RENSEIGNEE: 'Not specified',
  DIVORCE: 'Divorced',
  MARIE: 'Married',
  PACSE: 'Civil Union (PACS)',
  CELIBATAIRE: 'Single',
  SITUATIONFAMILIALE: 'Family Situation',
  SITUATIONFAMILIALEETURGENCE: 'Family Situation and Emergency',
  TELEPHONEPERSONNEL: 'Personal Phone',
  TELEPHONEPROFESSIONNEL: 'Professional Phone',
  GENRE: 'Gender',
  HOMME: 'Male',
  FEMME: 'Female',
  AUTRE: 'Other',
  INVALID_FILE_TYPE: 'Invalid file type. Please upload a .xls or .xlsx file.',

  // Keys for city autocompletion
  CITY: {
    SELECT_CITY: 'Select a city',
    SEARCH_ERROR: 'Error searching for cities',
    NO_RESULTS: 'No cities found',
    TYPE_TO_SEARCH: 'Type to search for a city',
  },
  VEUUILERIMPORTER: 'Please import a file',

  COMMUNITY: 'Community',
  ENTERPRISE: 'Enterprise',
  MEMBER: 'Member',
  DESCRIPTION: 'Description',
  TITLE: 'Title',
  BTN_DELETE: 'Delete',
  BTN_SAVE: 'Save',
  BTN_CONFIRM: 'Confirm',
  BTN_CANCEL: 'Cancel',
  ACCEPTER: 'Accept',
  BTN_CLOSE: 'Close',
  BTN_ADD: 'Add',
  BTN_UPDATE: 'Update',
  BTN_CREATE: 'Create',
  DUPLICATE: 'Duplicate',
  OPTIONAL: 'Optional',
  SELECT_ALL: 'Select All',
  CLEAR_ALL: 'Clear All',
  ALLOWED_FILE_TYPES: 'Allowed file types',
  THE_FIELD: 'Field ',
  INPUT_VALIDATION: {
    MIN: ` should have at least {{min}} characters`,
    MAX: ` should have at most {{max}} characters`,
  },
  SHOWING_ROWS_TABLE: 'Showing rows {{from}} to {{to}} of {{of}}',
  OPERATION_SUCCESS: 'Operation successful',
  OPERATION_SUCCESS_SEND_EMAIL: 'Email sent successfully',
  OPERATION_FAILED_SEND_EMAIL: 'Failed to send email',
  OPERATION_FAILED: 'Operation failed!',
  OPERATION_WARNING: 'This strategy is available in a premium plan! Please upgrade to premium plan to use it!',
  REFRESH: 'Refresh list',
  OPENS_NEW_TAB: 'Opens in a new tab',

  EXAMPLE: 'Example',
  LANG: 'Language',
  DAY_OF_WEEK: {
    MON: 'Monday',
    TUE: 'Tuesday',
    WED: 'Wednesday',
    THU: 'Thursday',
    FRI: 'Friday',
    SAT: 'Saturday',
    SUN: 'Sunday',
  },
  ADDRESS: 'Address',
  YES: 'Yes',
  NO: 'No',
  FROM: 'From',
  TO: 'To',
  HEIGHT: 'Height',
  WIDTH: 'Width',
  COLOR: 'Color',
  ERRORS: {
    OCCURED_TRY_AGAIN: 'An error occurred, please try again!',
    AI_QUOTA_EXCEEDED: 'Your AI quota is exceeded. Please contact us to request an increase.',
  },
  VIEW: 'View',
  SEND: 'Send',
  PREVIEW: 'Preview',
  DOWNLOAD: 'Download',
  EDIT: 'Edit',
  EDIT_CAMPAIGN_NAME: 'Edit campaign name',
  DELETE: 'Delete',
  CREATE: 'Create',
  SAVE: 'Save',
  SAVE_AND_CLOSE: 'Save and close',
  SAVING: 'Saving...',
  // Labels used by the interview workflow autosave status indicator.
  SAVED: 'Saved',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  CONFIRM: 'Confirm',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  STEPS: 'Steps',
  ADD: 'Add',
  ASSIGN: 'Assign',
  FIND_USER: 'Find an employee',
  FIND_USERS: 'Find employees',
  MONTHS: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  // Clés pour la configuration d'emails
  EMAIL_CONFIG: 'Email configuration :',
  PERSONAL_MAILBOX: 'Personal mailbox',
  EMYEHR_DEDICATED_BOX: 'Dedicated EmyeHR box',
  PERSONAL_MAILBOX_DESC: 'Emails are not received by EmyeHR. They will not be visible in the ATS.',
  EMYEHR_DEDICATED_BOX_DESC:
    'Recommended: Emails sent from this mailbox are received and automatically synchronized in EmyeHR (ATS).',

  ALL: 'All',
  All: 'All',

  FEMYE: 'HR AI Assistant',
  FNOAH: 'HR AI Coach',
  FJULIE: 'Legal AI Companion',
  FTHOMAS: 'CSRD AI Companion',
  FALAIN: 'Support AI Companion',
  FSECUREGPT: 'General AI Assistant',
  FCLARA: 'Recruitment AI Assistant',
  REPMESSUCCESS: 'Message reported successfully',
  REPMESFAILED: 'Message report failed',
  REPSEND: 'Send',
  NEW_VERSION_AVAILABLE: 'An app update is available. You must update the app to continue.',
  NEW_VERSION_AVAILABLE_TITLE: 'A new version is available',
  NEW_VERSION_AVAILABLE_MESSAGE: 'A new version is available. The site will reload.',
  NEW_VERSION_AVAILABLE_BUTTON: 'Update',
  REPCANCEL: 'Cancel',
  // Structured labels make AI-response reporting explicit, mandatory, and auditable.
  REPTITLE: 'Report this AI response',
  REPPH: 'Add an optional comment...',
  REPORT_REASON_LABEL: 'Report reason',
  REPORT_REASON_PLACEHOLDER: 'Select a reason',
  REPORT_REASON_HARMFUL: 'Unsafe or harmful content',
  REPORT_REASON_OFFENSIVE: 'Offensive or discriminatory content',
  REPORT_REASON_INCORRECT: 'Incorrect or misleading information',
  REPORT_REASON_PRIVACY: 'Privacy or data issue',
  REPORT_REASON_OTHER: 'Other',
  REPORT_COMMENT_LABEL: 'Comment',
  REPORT_OTHER_COMMENT_REQUIRED: 'Describe the issue when selecting “Other”.',
  REPORT_POLICY_NOTICE: 'Your report will be retained and reviewed by an authorized moderator.',
  REPORT_TERMS_LINK: 'Terms of Use',
  REPORT_PRIVACY_LINK: 'Privacy Policy',
  DESCRIPTION_ENTREPRISE: 'Company description',
  DESCRIPTION_ENTREPRISE_PLACEHOLDER: 'Company business',
  DESCRIPTION_ENTREPRISE_TOOLTIP:
    'This is a short description of your company to help Emye better understand your needs',

  // New translation keys for question editing functionality
  ADDNEWQUESTION: 'Add a new question',
  ENTERQUESTION: 'Enter question',
  QUESTIONSSAVEDSUCCESS: 'Questions saved successfully',
  QUESTIONADDEDSUCCESS: 'Question added successfully',
  QUESTIONDELETEDSUCCESS: 'Question deleted successfully',
  QUESTIONEDITEDSUCCESS: 'Question edited successfully',
  ERRORLOADINGQUESTIONS: 'Error loading questions',
  ERRORSAVINGQUESTIONS: 'Error saving questions',
  ERRORADDINGQUESTION: 'Error adding question',
  ERRORDELETINGQUESTION: 'Error deleting question',
  ERROREDITINGQUESTION: 'Error editing question',
  MISSINGPARAMETERS: 'Missing parameters',

  // Clés ajoutées pour harmonisation avec fr.ts
  NBR: 'Number',
  FNAME: 'First name',
  LNAME: 'Last name',
  CREATED_AT: 'Created at',
  IMG: 'Image',
  NAME: 'Name',
  IN_ANY_FIELD: 'in any field',
  SEARCH: 'Search',
  SUCCESS: 'Success',
  WARNING: 'Warning',
  INFO: 'Information',
  REFRESH_SUCCESS: 'Refresh successful',
  REFRESH_ERROR: 'Error during refresh',

  // Clés liées aux compétences
  SKILL_TYPE_REQUIRED: 'Skill type is required',
  SKILL_INVALID: 'Selected skill is invalid',
  SKILL_ADDED_ESSENTIAL: 'Skill added to essential skills',
  SKILL_ADDED_OPTIONAL: 'Skill added to optional skills',
  SKILL_REMOVED: 'Skill removed',
  LEGAL_MODAL: {
    DEFAULT_HEADER: 'Terms of Use',
    NO_CONTENT: 'No content available.',
    ACCEPT_TERMS: 'I accept the terms of use',
    TERMS_REQUIRED: 'You must accept the terms of use to continue.',
    ACCEPT_BUTTON: 'I accept',
    ERROR_LOADING: 'Error loading terms of use',
    ACCEPTANCE_SAVED: 'Your acceptance has been successfully saved',
    ERROR_SAVING: 'Error saving your acceptance',
    NO_DATA: 'No legal terms found.',
    SELECT_LANGUAGE: 'Language:',
  },
  SKILL_UPDATE_REMINDER: 'Remember to update the offer or regenerate it',
  SKILL_ALREADY_EXISTS_IN_ESSENTIAL: 'Skill already exists in essential skills',
  SKILL_ALREADY_EXISTS_IN_OPTIONAL: 'Skill already exists in optional skills',
  SKILL_ADDED_SUCCESSFULLY: 'Skill added successfully',

  // Clés liées aux offres d'emploi
  JOB_OFFER_UPDATED: 'Job offer updated successfully',
  JOB_OFFER_UPDATE_ERROR: 'An error occurred while updating the offer',
  JOB_OFFER_UPDATED_SUCCESSFULLY: 'Job offer updated successfully',
  ERROR_UPDATING_JOB_OFFER: 'An error occurred while updating the offer',
  // Audio keys
  AUDIO_BUTTON: 'Envoyer un message audio',
  MICROPHONE_ERROR: 'Erreur d\'accès au microphone',
  AUDIO_PROCESS_ERROR: 'Erreur lors du traitement audio',
  REALTIME_AUDIO_START: 'Démarrer l\'audio en temps réel',
  REALTIME_AUDIO_STOP: 'Arrêter l\'audio en temps réel',
  REALTIME_AUDIO_INDICATOR: 'Audio en direct : parlez naturellement, je répondrai quand vous ferez une pause',
  REALTIME_AUDIO_START_ERROR: 'Erreur lors du démarrage de l\'audio en temps réel',
  REALTIME_AUDIO_CONNECTION_LOST: 'Connexion audio temps réel interrompue',
  CONFIRM_DELETE: 'Confirm Deletion',
  TYPE_TO_CONFIRM_WARNING: 'This action is irreversible and will permanently delete this item.',
  TYPE_TO_CONFIRM_LABEL: 'To confirm, please type',
  REALTIME_TRANSCRIPTION_LOCAL: 'Local transcription',
  REALTIME_TRANSCRIPTION_SERVER: 'Server transcription',
  LAST_RESPONSE: 'Last response',
  // External API export keys
  PAYROLL_EXPORT: {
    EXTERNAL_API: {
      BUTTON: 'Export via API',
      TITLE: 'Export via API',
      SELECT_API: 'Select an API',
      SELECT_API_PLACEHOLDER: 'Choose an API...',
      NO_INTEGRATIONS: 'No integrations available',
      SELECT_SITE: 'Select a site',
      SELECT_SITE_PLACEHOLDER: 'Choose a site...',
      START_DATE: 'Start date',
      END_DATE: 'End date',
      CANCEL: 'Cancel',
      TRIGGER: 'Trigger export',
      SUCCESS: 'Export triggered successfully',
      ERROR: 'An error occurred during export',
      VALIDATION_REQUIRED: 'Please fill in all required fields',
      CONFIRM_TITLE: 'Confirm export',
      CONFIRM_MESSAGE: 'Are you sure you want to start the export via the API? Leave data will be sent to the external API.',
    },
  },
  SHARE: {
    EYEBROW: 'Social networks',
    BTN_TITLE: 'Share offer',
    MODAL_TITLE: 'Share the offer on social networks',
    LINK_ATTACHED: 'View offer details on the portal',
    INSTRUCTIONS_LABEL: 'Do you have additional instructions for writing the post? (optional)',
    INSTRUCTIONS_PLACEHOLDER: 'Example: make the post more dynamic, target junior profiles, highlight remote work...',
    WRITE_YOUR_POST: 'Write your own post',
    WRITE_PLACEHOLDER: 'Write your sharing message here...',
    ASK_AI: 'Ask AI to write',
    AI_PLACEHOLDER: 'Example: attractive remote senior developer role...',
    GENERATE_AI: 'Generate with AI',
    GENERATE_AI_PHOTO: 'Generate post',
    GENERATE_HINT: 'Text + visual prepared by Emye',
    POST_READY: 'Publication generated',
    REGENERATE_PUBLICATION: 'Regenerate',
    GENERATE_ERROR: 'Error generating post. Please try again.',
    GENERATE_IMAGE_ERROR: 'Error generating image. Please try again.',
    SAVE_ERROR: 'Error saving post. Please try again.',
    CUSTOMIZE_AI_MESSAGE: 'Review the result',
    CUSTOMIZE_PLACEHOLDER: 'The AI-generated message will appear here and remain editable...',
    PREVIEW: 'Post preview',
    IMAGE_ALT: 'Generated image for the job offer',
    IMAGE_PLACEHOLDER: 'The generated image will appear here',
    PREVIEW_TEXT_PLACEHOLDER: 'The publication text will appear here after generation.',
    REFRESH_IMAGE: 'Generate a new image',
    REFRESHING_IMAGE: 'Generating...',
    DOWNLOAD_IMAGE: 'Download image',
    IMAGE_DOWNLOADED: 'Image downloaded.',
    IMAGE_PREVIEW_OPEN: 'Enlarge generated image',
    IMAGE_PREVIEW_CLOSE: 'Close image preview',
    SHARE_ON: 'Share on',
    CHOOSE_NETWORK: 'Choose the network to prepare',
    NETWORK_LINKEDIN: 'LinkedIn',
    NETWORK_FACEBOOK: 'Facebook',
    NETWORK_X: 'X (Twitter)',
    NETWORK_INDEED: 'Indeed',
    NETWORK_INSTAGRAM: 'Instagram',
    NETWORK_TIKTOK: 'TikTok',
    GUIDE_EYEBROW: 'Guided assistant',
    GUIDE_TITLE: 'Your publication is ready to be prepared',
    GUIDE_SUBTITLE: 'Emye prepares the text, the visual and the offer link. You stay in control to review and publish on the selected network.',
    GUIDE_STEP_1_TITLE: 'Choose the network',
    GUIDE_STEP_1_TEXT: 'Click the network where you want to publish.',
    GUIDE_STEP_2_TITLE: 'Emye prepares the content',
    GUIDE_STEP_2_TEXT: 'The text is copied and the visual is ready.',
    GUIDE_STEP_3_TITLE: 'The network opens',
    GUIDE_STEP_3_TEXT: 'The selected site opens in a new tab.',
    GUIDE_STEP_4_TITLE: 'Paste the text',
    GUIDE_STEP_4_TEXT: 'Click in the publication area and press Ctrl + V.',
    GUIDE_STEP_5_TITLE: 'Review and publish',
    GUIDE_STEP_5_TEXT: 'Review, add the visual if needed, then publish.',
    PREPARE_FOR: 'Prepare for',
    PREPARE_DESCRIPTION_LINKEDIN: 'Text copied + visual to upload',
    PREPARE_DESCRIPTION_FACEBOOK: 'Text copied + visual to upload',
    PREPARE_DESCRIPTION_X: 'Short text, no visible link',
    PREPARE_DESCRIPTION_INDEED: 'Offer text copied',
    PREPARE_DESCRIPTION_INSTAGRAM: 'Text copied + visual ready',
    PREPARE_DESCRIPTION_TIKTOK: 'Text copied + visual to download',
    NETWORK_HELP: 'Click a network: the text and link will be copied, then the site will open. Download the visual to add it manually.',
    NEXT_STEPS_EYEBROW: 'What to do now',
    FOLLOW_NETWORK_GUIDE: 'Follow the guide for the selected network',
    NETWORK_GUIDE_TITLE: '{{network}} publication ready',
    NETWORK_GUIDE_SUBTITLE_LINKEDIN: 'Create a normal post: paste the link to generate the preview. Once the preview is displayed, you can remove the link from the text to keep the post cleaner.',
    NETWORK_GUIDE_SUBTITLE_FACEBOOK: 'Create a normal post: paste the link to generate the preview. Once the preview is displayed, you can remove the link from the text to keep the post cleaner.',
    NETWORK_GUIDE_SUBTITLE_X: 'The text is generated to fit X limits. No visible link is added to the post.',
    NETWORK_GUIDE_SUBTITLE_INDEED: 'The text is copied to help you complete or create your Indeed job post.',
    NETWORK_GUIDE_SUBTITLE_INSTAGRAM: 'The text is copied and the visual is ready to download, then upload to Instagram.',
    NETWORK_GUIDE_SUBTITLE_TIKTOK: 'For now, download the visual. The TikTok video can be generated later from this image.',
    PREPARED_TEXT_COPIED: 'Text copied',
    PREPARED_TEXT_LINK_COPIED: 'Text and link copied',
    PREPARED_TEXT_PREFILLED: 'Text prefilled',
    PREPARED_X_TEXT_READY: 'X text ready and shortened',
    PREPARED_NO_VISIBLE_LINK: 'No visible link added',
    PREPARED_LINK_READY: 'Offer details available on the portal',
    PREPARED_IMAGE_DOWNLOADED: 'Visual downloaded',
    PREPARED_IMAGE_TO_DOWNLOAD: 'Visual to download',
    PREPARED_NETWORK_OPENED: 'Site opened',
    PREPARED_NETWORK_READY_TO_OPEN: 'Site ready to open',
    NETWORK_GUIDE_STEP_LINKEDIN_1: 'Click “Open LinkedIn”.',
    NETWORK_GUIDE_STEP_LINKEDIN_2: 'In LinkedIn, click “Start a post”.',
    NETWORK_GUIDE_STEP_LINKEDIN_3: 'Click “Copy link”, paste it to generate the preview. Once the preview is displayed, you can remove the link from the text to keep the post cleaner.',
    NETWORK_GUIDE_STEP_LINKEDIN_4: 'Click “Copy text again”, paste it, then add the downloaded visual.',
    NETWORK_GUIDE_STEP_LINKEDIN_5: 'Review, then publish.',
    NETWORK_GUIDE_STEP_FACEBOOK_1: 'Click “Open Facebook”.',
    NETWORK_GUIDE_STEP_FACEBOOK_2: 'In Facebook, create a normal post.',
    NETWORK_GUIDE_STEP_FACEBOOK_3: 'Click “Copy link”, paste it to generate the preview. Once the preview is displayed, you can remove the link from the text to keep the post cleaner.',
    NETWORK_GUIDE_STEP_FACEBOOK_4: 'Click “Copy text again”, paste it, then add the downloaded visual.',
    NETWORK_GUIDE_STEP_FACEBOOK_5: 'Review, then publish.',
    NETWORK_GUIDE_STEP_X_1: 'Click “Open X”.',
    NETWORK_GUIDE_STEP_X_2: 'X opens with shortened text and no visible link.',
    NETWORK_GUIDE_STEP_X_3: 'If you want to add the image, download the visual then choose it with the media icon.',
    NETWORK_GUIDE_STEP_X_4: 'Review, then publish.',
    NETWORK_GUIDE_STEP_INDEED_1: 'Click “Open Indeed”.',
    NETWORK_GUIDE_STEP_INDEED_2: 'Open or create the relevant job post.',
    NETWORK_GUIDE_STEP_INDEED_3: 'Paste the text with Ctrl + V in the description.',
    NETWORK_GUIDE_STEP_INDEED_4: 'Check the information, then save or publish.',
    NETWORK_GUIDE_STEP_INSTAGRAM_1: 'Click “Open Instagram”.',
    NETWORK_GUIDE_STEP_INSTAGRAM_2: 'Create a new post.',
    NETWORK_GUIDE_STEP_INSTAGRAM_3: 'Download the visual if not done yet, then choose it in Instagram.',
    NETWORK_GUIDE_STEP_INSTAGRAM_4: 'Paste the text with Ctrl + V in the description.',
    NETWORK_GUIDE_STEP_INSTAGRAM_5: 'Review, then publish.',
    NETWORK_GUIDE_STEP_TIKTOK_1: 'Click “Open TikTok”.',
    NETWORK_GUIDE_STEP_TIKTOK_2: 'Create the post from TikTok Web or the mobile app.',
    NETWORK_GUIDE_STEP_TIKTOK_3: 'Download the visual if not done yet. The video version will be added in a later step.',
    NETWORK_GUIDE_STEP_TIKTOK_4: 'Paste the text with Ctrl + V, then publish.',
    ASSISTANT_EYEBROW: 'Emye Assistant',
    COMPACT_STEP_1_TITLE: 'Generate your publication',
    COMPACT_STEP_2_TITLE: 'Choose a network',
    COMPACT_STEP_3_TITLE: 'Emye guides you through publication',
    ASSISTANT_TITLE: 'Your {{network}} post is ready',
    ASSISTANT_SUBTITLE: 'Follow the steps below to finalize your publication without getting lost.',
    ASSISTANT_LAST_STEP: 'Steps to follow:',
    ASSISTANT_CHECK_TEXT_COPIED: 'Text copied automatically',
    ASSISTANT_CHECK_TEXT_LINK_COPIED: 'Text and link copied automatically',
    ASSISTANT_CHECK_VISUAL_READY: 'Visual ready',
    ASSISTANT_CHECK_IMAGE_READY: 'Image ready',
    ASSISTANT_CHECK_LINK_READY: 'Offer details available on the portal',
    ASSISTANT_CHECK_TEXT_LINK_PREFILLED: 'Text + link prefilled',
    ASSISTANT_CHECK_LINKEDIN_OPENED: 'LinkedIn opened',
    ASSISTANT_CHECK_FACEBOOK_OPENED: 'Facebook opened',
    ASSISTANT_CHECK_X_OPENED: 'X opened',
    ASSISTANT_CHECK_INDEED_OPENED: 'Indeed opened',
    ASSISTANT_CHECK_INSTAGRAM_OPENED: 'Instagram opened',
    ASSISTANT_CHECK_TIKTOK_OPENED: 'TikTok opened',
    ASSISTANT_STEP_LINKEDIN_1: 'LinkedIn just opened in a new tab.',
    ASSISTANT_STEP_LINKEDIN_2: 'Click “Start a post”.',
    ASSISTANT_STEP_LINKEDIN_3: 'Press Ctrl + V to paste the text and link prepared by Emye.',
    ASSISTANT_STEP_LINKEDIN_4: 'Click the photo icon and upload the downloaded visual.',
    ASSISTANT_STEP_LINKEDIN_5: 'Review, then publish.',
    ASSISTANT_STEP_FACEBOOK_1: 'Facebook just opened in a new tab.',
    ASSISTANT_STEP_FACEBOOK_2: 'Click in the publication area.',
    ASSISTANT_STEP_FACEBOOK_3: 'Press Ctrl + V to paste the text prepared by Emye.',
    ASSISTANT_STEP_FACEBOOK_4: 'Check the text and the offer link.',
    ASSISTANT_STEP_FACEBOOK_5: 'Click Publish.',
    ASSISTANT_STEP_X_1: 'X just opened in a new tab.',
    ASSISTANT_STEP_X_2: 'The text and link are already prefilled.',
    ASSISTANT_STEP_X_3: 'Review the post content.',
    ASSISTANT_STEP_X_4: 'Adjust the text if needed.',
    ASSISTANT_STEP_X_5: 'Click Publish.',
    ASSISTANT_STEP_INDEED_1: 'Indeed just opened in a new tab.',
    ASSISTANT_STEP_INDEED_2: 'Open or create the relevant job post.',
    ASSISTANT_STEP_INDEED_3: 'Press Ctrl + V to paste the text prepared by Emye.',
    ASSISTANT_STEP_INDEED_4: 'Check the offer information.',
    ASSISTANT_STEP_INDEED_5: 'Publish or save the job post.',
    ASSISTANT_STEP_INSTAGRAM_1: 'Instagram just opened.',
    ASSISTANT_STEP_INSTAGRAM_2: 'Create a new post.',
    ASSISTANT_STEP_INSTAGRAM_3: 'Add the visual generated by Emye.',
    ASSISTANT_STEP_INSTAGRAM_4: 'Click in the description area.',
    ASSISTANT_STEP_INSTAGRAM_5: 'Press Ctrl + V to paste the text.',
    ASSISTANT_STEP_INSTAGRAM_6: 'Review, then publish.',
    ASSISTANT_STEP_TIKTOK_1: 'TikTok just opened.',
    ASSISTANT_STEP_TIKTOK_2: 'Create a new post.',
    ASSISTANT_STEP_TIKTOK_3: 'Add the visual generated by Emye.',
    ASSISTANT_STEP_TIKTOK_4: 'Click in the description area.',
    ASSISTANT_STEP_TIKTOK_5: 'Press Ctrl + V to paste the text.',
    ASSISTANT_STEP_TIKTOK_6: 'Review, then publish.',
    RECOPY_TEXT: 'Copy text again',
    REOPEN_NETWORK: 'Reopen {{network}}',
    OPEN_NETWORK: 'Open {{network}}',
    I_PUBLISHED: 'I published it',
    MARKED_PUBLISHED: 'Publication marked as completed.',
    COPIED_CLIPBOARD: 'Text and link copied. Paste them into the publication field.',
    LINK_COPIED_CLIPBOARD: 'Link copied.',
    COPY_FAILED: 'Copy failed. Please try again.',
    POPUP_BLOCKED: 'The browser blocked the site opening. Allow pop-ups, then try again.',
    COPY_LINK: 'Copy link',
    CLOSE: 'Close',
    URL_PORTAL_MISSING: 'Please fill in the portal URL.',
  },
}
